import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

const AboutTabs = ({ benefits }) => {


  return (
    <>
      <Tabs>
        <TabList className="nav nav-tabs h3-para d-flex justify-content-between flex-wrap gap-2 align-items-center ">
          <Tab className="nav-link border-0 fw-light me-1 h3-heading">{benefits.name}</Tab>
          <Tab className="nav-link border-0 h3-heading me-1">{benefits.name2}</Tab>
          <Tab className="nav-link  border-0  h3-heading me-1">{benefits.name3}</Tab>
        </TabList>


        <div className="tab-content pt-lg-3 text-center text-lg-start">
          <TabPanel>
            <p className="font-gordita h3-para">{benefits.value}</p>
          </TabPanel>
          <TabPanel>
            <p className="font-gordita h3-para">{benefits.value2} </p>
          </TabPanel>
          <TabPanel>
            <p className="font-gordita h3-para">{benefits.value3} </p>
          </TabPanel>
        </div>
   
      </Tabs>
    </>
  );
};

export default AboutTabs;
